import { IProduct } from '../../../../store/model/authUser/types';

export enum EProductPlan {
    ESSENTIAL = 'ESSENTIAL',
    PREMIUM = 'PREMIUM',
    PROFESSIONAL = 'PROFESSIONAL',
    ENTERPRISE = 'ENTERPRISE',
};

export enum EProductPack {
    ESSENTIAL = 10,
    PREMIUM = 6,
    PROFESSIONAL = 7,
    ENTERPRISE = 8,
};

export enum EProductFrequency {
    ANNUALLY = 12,
    MONTHLY = 1,
};

export interface IPricingProducts {
    [frequency: number]: {
        [pack: number]: IProduct;
    };
};

export interface IProductPrice {
    upTo?: number;
    price: number;
}

export type TProductPrices = IProductPrice[];

export type TProductFrequencyPrices = { [key: number]: TProductPrices };

export type TProductPlanPrices = { [key: number]: TProductFrequencyPrices };
